import AccountDeletionSuccess from "../components/AccountDeletionSuccess/AccountDeletionSuccess";
import useNavigation from "../hooks/navigation";

const AccountDeletionSuccessPage: React.FC = () => {
  const navigation = useNavigation();

  return (
    <div>
      <AccountDeletionSuccess
        onBackButton={() => {
          navigation.goToLandingPage();
        }}
      />
    </div>
  );
};

export default AccountDeletionSuccessPage;
